import Typography from '@mui/material/Typography';
import React from 'react';

import { ExistingImpactData } from '../../api/types';

interface AccessPointImpactProps {
    existingIMPACTs: ExistingImpactData[];
    translations: Record<string, string>;
}

export const AccessPointImpact: React.FC<AccessPointImpactProps> = ({ existingIMPACTs, translations }) => (
    <>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            {translations.ACCESS_POINT_EXISTING_IMPACT_TITLE}
        </Typography>

        {existingIMPACTs.map((impact: ExistingImpactData) => (
            <Typography variant="subtitle2" key={impact.IMPACTCode}>
                {impact.IMPACTCode} {impact.IMPACTDescription}
            </Typography>
        ))}

        {!existingIMPACTs.length && (
            <Typography variant="subtitle2" color="textSecondary">
                {translations.GLOBAL_NONE}
            </Typography>
        )}
    </>
);
